import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Button, Card, CardContent, CardActions, Typography, CircularProgress } from '@mui/material'
import { triggerGeocoding, triggerEmbeddings } from 'src/redux/backgroundJobLauncher'

const jobs = [
  {
    name: 'Update Geocoding Data',
    description: 'Geocodes job locations that are missing coordinates.',
    action: triggerGeocoding,
    loadingKey: 'geocodingLoading',
  },
  {
    name: 'Update Embeddings',
    description: 'Generates embeddings for jobs, specialties, and subspecialties.',
    action: triggerEmbeddings,
    loadingKey: 'embeddingsLoading',
  },
]

const BackgroundJobLauncher = () => {
  const dispatch = useDispatch()
  const { geocodingLoading, embeddingsLoading } = useSelector(
    state => state.backgroundJobLauncher,
  )
  const loadingState = { geocodingLoading, embeddingsLoading }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant='h5' sx={{ mb: 3 }}>
        Background Job Launcher
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        {jobs.map(job => {
          const loading = loadingState[job.loadingKey]
          return (
            <Card key={job.name} sx={{ width: 300 }}>
              <CardContent>
                <Typography variant='h6'>{job.name}</Typography>
                <Typography variant='body2' color='text.secondary'>
                  {job.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  variant='contained'
                  onClick={() => dispatch(job.action())}
                  disabled={loading}
                  startIcon={loading ? <CircularProgress size={16} /> : null}
                >
                  {loading ? 'Triggering...' : 'Run'}
                </Button>
              </CardActions>
            </Card>
          )
        })}
      </Box>
    </Box>
  )
}

export default BackgroundJobLauncher
